import type { VueConstructor } from 'vue'

declare module 'vue/types/vue' {
  interface Vue {
    $browserNotification: BrowserNotification;
  }
}

class BrowserNotification {
  show(title: string, options?: NotificationOptions | undefined): Promise<Notification> {
    return new Promise((resolve, reject) => {
      if (!('Notification' in window)) {
        console.error('Ce navigateur ne prends pas en charge les notifications')
      }
      else if (Notification.permission === 'granted') {
        return resolve(new Notification(title, options))
      }
      else if (Notification.permission === 'denied') {
        return reject(new Error(`Notification permission ${Notification.permission}`))
      }
      else {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            return resolve(new Notification(title, options))
          }
        })
      }
    })
  }
}

export default {
  install: (Vue: VueConstructor) => {
    Vue.prototype.$browserNotification = new BrowserNotification()
  },
}
